import IconButton from '@components/v2/ui/IconButton/IconButton';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import { useTranslation } from '../../../../modules/translation/TranslationContext';
import { VirtualizedTableHeaderAction } from './VirtualizedTable.types';

interface VirtualizedTableHeaderActionButtonProps {
  action: VirtualizedTableHeaderAction;
}

const VirtualizedTableHeaderActionButton = ({
  action,
}: VirtualizedTableHeaderActionButtonProps) => {
  const { translate } = useTranslation();
  const label = translate(action.label);

  return (
    <Tooltip placement="top" TooltipContent={label}>
      <IconButton
        icon={action.icon}
        size="medium"
        ariaLabel={label}
        testId={action.testId}
        to={action.to}
        onClick={action.onClick}
      />
    </Tooltip>
  );
};

export default VirtualizedTableHeaderActionButton;
